import Axios from 'axios';

export default {
	state: {
		currentUser: null,
		isAuthenticated: false
	},
	mutations: {
		SET_CURRENT_USER (state, user) {
			state.currentUser = user;
		},
		SET_IS_AUTHENTICATED (state, value) {
			state.isAuthenticated = value;
		}
	},
	actions: {

		async getCurrentUser (context, uuid) {
			try {
				const response = await Axios.get('/users/uuid/' + uuid);
				context.commit('SET_CURRENT_USER', response.data);
				context.commit('SET_IS_AUTHENTICATED', true);
			} catch (error) {
				console.log(error);
				throw error;
			}
		},

		removeCurrentUser (context) {
			context.commit('SET_CURRENT_USER', null);
			context.commit('SET_IS_AUTHENTICATED', false);
		}
	}
};



// WEBPACK FOOTER //
// ./src/store/session.js